import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '../pages/404.vue'
import Auth from '../pages/SignIn.vue'
import Dashboard from '../pages/Dashboard.vue'
import Index from '../pages/Index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      component: Index,
      path: '/',
      meta: { title: process.env.VUE_APP_TITLE }
    },
    {
      component: Auth,
      path: '/auth',
      meta: { title: "Login - Time-Lapse Systems" }
    },
    {
      component: NotFound,
      meta: { title: "404 Not Found"},
      name: '404',
      path: '/404',
      props: true
    },
    {
      component: Dashboard,
      meta: { title: "Dashboard"},
      name: 'Dashboard',
      path: '/dashboard',
      props: true
    },
    {
      component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin.vue'),
      name: 'AdminPage',
      path: '/admin',
      redirect: '/admin/account',
      children: [
        {
          component: () => import(/* webpackChunkName: "admin" */ '../pages/AdminAccount.vue'),
          meta: { title: "Admin - Account" },
          name: 'AdminAccountPage',
          path: 'account',
          props: true
        },
        {
          component: () => import(/* webpackChunkName: "admin" */ '../pages/AdminApplications.vue'),
          meta: { title: "Admin - Applications" },
          name: 'AdminApplicationsPage',
          path: 'applications',
          props: true
        },
        {
          component: () => import(/* webpackChunkName: "admin" */ '../pages/AdminBilling.vue'),
          meta: { title: "Admin - Billing" },
          name: 'AdminBillingPage',
          path: 'billing',
          props: true
        },
        {
          component: () => import(/* webpackChunkName: "admin" */ '../pages/AdminUsers.vue'),
          meta: { title: "Admin - Users" },
          name: 'AdminUsersPage',
          path: 'users',
          props: true
        },
      ]
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'ClientsPage',
      path: '/clients',
      props: {resource: 'clients', title: "Clients"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'ClientCreate',
      path: '/clients/new',
      props: (route) => ({resource: 'clients', title: "New Client"}),
    },
    {
      path: '/clients/:id',
      redirect: '/clients/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'ClientPage',
      path: '/clients/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'clients', title: "Client"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'EditsPage',
      path: '/edits',
      props: {resource: 'edits', title: "Edits"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'EditCreate',
      path: '/edits/new',
      props: (route) => ({resource: 'edits', title: "New Edit"}),
    },
    {
      path: '/edits/:id',
      redirect: '/edits/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'EditPage',
      path: '/edits/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'edits', title: "Edit"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'LocationsPage',
      path: '/locations',
      props: {resource: 'locations', title: "Locations"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'LocationCreate',
      path: '/locations/new',
      props: (route) => ({resource: 'locations', title: "New Location"}),
    },
    {
      path: '/locations/:id',
      redirect: '/locations/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'LocationPage',
      path: '/locations/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'locations', title: "Location"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'MapsPage',
      path: '/maps',
      props: {resource: 'maps', title: "Maps"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'MapCreate',
      path: '/maps/new',
      props: (route) => ({resource: 'maps', title: "New Map"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Map.vue'),
      name: 'MapPage',
      path: '/maps/:id',
      props: (route) => ({id: route.params.id, resource: 'maps', title: "Map"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'Map',
      path: '/maps/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'maps', title: "Map"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'PartnersPage',
      path: '/partners',
      props: {resource: 'partners', title: "Partners"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'PartnerCreate',
      path: '/partners/new',
      props: (route) => ({resource: 'partners', title: "New Partner"}),
    },
    {
      path: '/partners/:id',
      redirect: '/partners/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'PartnerPage',
      path: '/partners/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'partners', title: "Partner"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'ProjectsPage',
      path: '/projects',
      props: {resource: 'projects', title: "Projects"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'ProjectCreate',
      path: '/projects/new',
      props: (route) => ({resource: 'projects', title: "New Project"}),
    },
    {
      path: '/projects/:id',
      redirect: '/projects/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'ProjectPage',
      path: '/projects/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'projects', title: "Project"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'SystemsPage',
      path: '/cameras',
      props: {resource: 'cameras', title: "Camera Systems"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'SystemCreate',
      path: '/cameras/new',
      props: (route) => ({resource: 'cameras', title: "New Camera System"}),
    },
    {
      path: '/cameras/:id',
      redirect: '/cameras/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'SystemEditPage',
      path: '/cameras/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'cameras', title: "Camera System"}),
    },
    {
      component: () => import(/* webpackChunkName: "user" */ '../pages/User.vue'),
      name: 'UserIndex',
      path: '/user',
      redirect: "/user/profile",
      children: [
        {
          component: () => import(/* webpackChunkName: "resource" */ '../pages/User.vue'),
          name: 'UserProfile',
          path: 'profile',
          props: {resource: 'profile', title: "User Profile"},
        },
        {
          component: () => import(/* webpackChunkName: "resource" */ '../pages/User.vue'),
          name: 'UserSettings',
          path: 'settings',
          props: {resource: 'settings', title: "User Settings"},
        },
      ]
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'UsersPage',
      path: '/users',
      props: {resource: 'users', title: "Users"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'UserCreate',
      path: '/users/new',
      props: (route) => ({resource: 'users', title: "New User"}),
    },
    {
      path: '/users/:id',
      redirect: '/users/:id/edit'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'UserPage',
      path: '/users/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'users', title: "User"}),
    },
    {
      component: () => import(/* webpackChunkName: "support" */ '../pages/UserSupport.vue'),
      name: 'SupportPage',
      path: '/support'
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'ViewsPage',
      path: '/views',
      props: {resource: 'views', title: "Views"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'ViewCreate',
      path: '/views/new',
      props: (route) => ({resource: 'views', title: "New View"}),
    },
    {
      component: () => import(/* webpackChunkName: "viewer" */ '../pages/Viewer.vue'),
      name: 'Viewer',
      path: '/views/:id',
      props: true,
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'ViewPage',
      path: '/views/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'views', title: "View"}),
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/Resource.vue'),
      name: 'VideosPage',
      path: '/videos',
      props: {resource: 'videos', title: "Videos"},
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceCreate.vue'),
      name: 'VideoCreate',
      path: '/videos/new',
      props: (route) => ({resource: 'videos', title: "New Video"}),
    },
    {
      component: () => import(/* webpackChunkName: "video" */ '../pages/Video.vue'),
      name: 'Videoer',
      path: '/videos/:id',
      props: true,
    },
    {
      component: () => import(/* webpackChunkName: "resource" */ '../pages/ResourceSingle.vue'),
      name: 'VideoPage',
      path: '/videos/:id/edit',
      props: (route) => ({id: route.params.id, resource: 'videos', title: "Video"}),
    }
  ]
})
